module.exports = __webpack_public_path__ + "img/gallery_image-5.be4e1c8.jpg";